import React from "react";
import { ToggleButton, FormControl, FormLabel } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import { Field } from "formik";
import { ToggleButtonGroup } from "formik-mui";

export function ToggleButtonControl({ name, label, options, helperText }) {
  return (
    <FormControl>
      <FormLabel component="legend" htmlFor={`form-control-${name}`}>
        {label}
      </FormLabel>
      <Field
        component={ToggleButtonGroup}
        name={name}
        exclusive
        id={`form-control-${name}`}
        sx={{ mt: 1 }}
        type="checkbox"
      >
        {options.map(({ option, value }) => (
          <ToggleButton key={value} value={value}>
            {option}
          </ToggleButton>
        ))}
      </Field>
      {helperText && (
        <FormHelperText sx={{ mx: 0 }}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
